import React from "react";
import { Field, FieldProps, FieldRenderProps } from "react-final-form";
import { IListOption } from "../../../store/models/listOption.models";
import "./SingleSelectField.scss";

/**
 * @param {string} label - user facing string used for the title of the Select.
 * @param {Array<IListOption>} - options presented in the Select to the user.
 */
export interface ISelectProps<El extends HTMLSelectElement> extends FieldProps<any, FieldRenderProps<any, El>> {
  label?: string;
  options: Array<IListOption>;
  bare?: boolean;
  inputProps?: any;
}

export interface ISelectRenderProps extends ISelectProps<HTMLSelectElement>, FieldRenderProps<any, HTMLSelectElement> {}

/**
 * The standard select component.
 *
 * Displays a list of IListOption objects.
 */
export class SingleSelect extends React.Component<ISelectRenderProps> {
  render() {
    const { bare, label, options, input, meta, disabled, isRequired, selected, inputProps } = this.props;

    if (bare) {
      return (
        <select
          className={`single-select-field-v2__field-input field-input ${meta.touched && meta.error ? "error" : ""}`}
          {...input}
          disabled={disabled}>
          {options.map(item => (
            <option key={item.value} value={item.value} disabled={item.disabled}>
              {item.key}
            </option>
          ))}
        </select>
      );
    }

    return (
      <div
        className={
          disabled
            ? "single-select-field-v2-disabled"
            : meta.touched && meta.error
              ? "single-select-field-v2-error"
              : "single-select-field-v2"
        }>
        <ul>
          <li>
            <label>{label}</label>
            {isRequired ? <label className="required">&nbsp;*</label> : ""}
          </li>
          <li>
            <select className="single-select-field-v2__field-input" {...input} {...inputProps} disabled={disabled}>
              {options.map(item => (
                <option key={item.value} value={item.value} disabled={item.disabled}>
                  {item.key}
                </option>
              ))}
            </select>
          </li>
          {meta.touched && meta.error && <span>{meta.error}</span>}
        </ul>
      </div>
    );
  }
}

// HTMLSelectElement

export interface ISelectFieldProps extends ISelectProps<HTMLSelectElement> {}

export default function SingleSelectField(props: ISelectFieldProps) {
  return (
    <Field
      component={SingleSelect}
      parse={(value, name) => {
        const id = parseInt(value, 10);
        /*
        This was once a way to avoid having to filter the default value out of every
        model to DTO conversion. However, in order to differentiate between deleting
        an analyzer column and selecting a default value from the dropdown we need to
        allow the default Option value to persist. A possible solution is to add a
        'doesFilterDefaultValues' prop but for now were just gonna filter default
        values in every dto conversion.
        if (id === defaultOptionValue) {
          return undefined;
        }
        */
        return id;
      }}
      {...props}
    />
  );
}
